<template>
    <modal :open="modalIsOpen" @close="modalIsOpen = false">
        <template v-slot:title> Détails du panier </template>

        <template v-slot:content>
            <ModalContent ref="childRef" />
        </template>
    </modal>
</template>

<script setup>
import { ref } from 'vue';
import ModalContent from './ModalContent.vue';

const modalIsOpen = ref(false);
const childRef = ref(null);

const addToCart = async (type, bike, size) => {
    childRef.value.addToCart(type, bike, size);
    modalIsOpen.value = true;
};

defineExpose({
    addToCart,
});
</script>
